export default __webpack_public_path__ + "static/media/ilfracombeBuildings.7232b092.png";